'use strict';

require('./vendor');

import Cookies from 'js-cookie';

jQuery(document).ready(function ($) {
  // ALLE CUSTOM JS KOMT HIER

  // SUBMENU BIG
  var submenuItems = $('.submenu-button').length;
  $('.submenu-big').addClass('total' + submenuItems);

  // HTML5 custom validation message
  var elements = document.getElementsByTagName("INPUT");
  for (var i = 0; i < elements.length; i++) {
    elements[i].oninvalid = function (e) {
      e.target.setCustomValidity("");
      if (!e.target.validity.valid) {
        e.target.setCustomValidity("Dit veld is verplicht.");
      }
    };
    elements[i].oninput = function (e) {
      e.target.setCustomValidity("");
    };
  }

  // $('select[name="form_providers_type"]').change(function() {
  //   var $input = $('input[name="form_providers_input"]').attr('required', true);
  //   var $optioneel = $('.optioneel-text p');
  //
  //   if ($(this).val() == 'huisarts') {
  //     $input.attr('required', true);
  //     $optioneel.addClass('hide');
  //   } else {
  //     $input.attr('required', false);
  //     $optioneel.removeClass('hide');
  //   }
  // });

  // FAQ
  $('.faq-icon, .faq-question span').on('click', function (e) {
    e.preventDefault();

    parent = $(this).closest('.faq-item');

    if (parent.hasClass('faq-active')) {
      parent.find('.faq-extended').slideUp(300);
      parent.removeClass('faq-active');
    } else {
      parent.find('.faq-extended').slideDown();
      parent.addClass('faq-active');
    }
  });

  // Scroll to anchor
  $('.scroll-to-anchor').on('click', function (e) {
    e.preventDefault();

    $('html, body').animate({
      scrollTop: $($.attr(this, 'href')).offset().top - 100
    }, 300);
  });

  // LANGUAGES
  $('#language-active').on('click', function (e) {
    e.preventDefault();
    $('#languages').toggleClass('active');
  });

  // TABS
  $('#tab1-button').on('click', function (e) {
    e.preventDefault();
    $('header').removeClass().addClass('after-five animation-out');
    $(this).closest('.row').height($('#tab2').outerHeight());
    $('html,body').animate({
      scrollTop: 0
    }, 300);
    setTimeout(function () {
      $('header').removeClass('animation-out');
    }, 400);
  });

  $('#tab2-button').on('click', function (e) {
    e.preventDefault();
    $('header').removeClass().addClass('before-five animation-out');
    $(this).closest('.row').height($('#tab1').outerHeight());
    $('html,body').animate({
      scrollTop: 0
    }, 300);
    setTimeout(function () {
      $('header').removeClass('animation-out');
    }, 400);
  });

  //FILTER CURSUSSEN
  $('.filter a').on('click', function (e) {
    e.preventDefault();

    $('#cursussen').css('height', '0px');
    $('#cursussen tr').not('.table-head').fadeOut(300);

    $(this).toggleClass('active');

    var selectedFilters = $('.filter a.active').map(function () {
      return $(this).data('filter');
    }).get();

    $('#cursussen tr').each(function () {
      var $this = $(this);

      var length = selectedFilters.length;

      // check if one filter matches
      for (var i = 0; i < length; i++) {
        var filters = selectedFilters[i];
        if ($this.is('[data-filter*="' + filters + '"]')) {
          setTimeout(function () {
            $this.fadeIn();
          }, 300);
        }
      }
    });

    if (!$('.filter a').hasClass('active')) {
      setTimeout(function () {
        $('#cursussen tr').not('.table-head').fadeIn();
      }, 300);
    }
  });

  // STICKY NAV
  function Scrolled() {
    if ($('html,body').scrollTop() > 1) {
      $('body').addClass('scrolled');
    } else {
      $('body').removeClass('scrolled');
    }
  };

  // SEARCH
  $('#search a').on('click', function (e) {
    e.preventDefault();
    $('body').addClass('search-open');
    setTimeout(function () {
      $('nav .site-search input[type="text"]').focus();
    }, 300);
  });

  $('#close-search').on('click', function (e) {
    e.preventDefault();
    $('body').removeClass('search-open');
  });

  // SUBMENU
  $('.page_item_has_children ul').each(function () {
    $('<button class="open-sub"></button>').insertAfter($(this).parent().children('a').first());
  });

  $(document).on('click', '.open-sub', function () {
    $(this).next('ul').toggleClass('active');
    $(this).toggleClass('active');
  });

  // MENU
  $('#menu-mobile').on('click', function (e) {
    e.preventDefault();
    $('body').toggleClass('menu-open');
  });

  // TIME SWITCH
  function calcTime(city, offset) {
    // create Date object for current location
    var d = new Date();

    // convert to msec
    // subtract local time zone offset
    // get UTC time in msec
    var utc = d.getTime() + (d.getTimezoneOffset() * 60000);

    // create new Date object for different city
    // using supplied offset
    var nd = new Date(utc + (3600000 * offset));

    // return time as a string
    return "The local time for city" + city + " is " + nd.toLocaleString();

    alert(utc);
  }

  var d = new Date();
  var n = d.getDay();
  var t = d.getHours();

  if (n > 5 || n == 0) {
    $('.frontpage header').removeClass().addClass('after-five');
    setTimeout(function () {
      $('.frontpage header > .row').height($('#tab2').outerHeight());
      $('.triagetool-wrapper').css('display', 'block');
    }, 1000);
  } else if (t < 8 || t >= 17) {
    $('.frontpage header').removeClass().addClass('after-five');
    setTimeout(function () {
      $('.frontpage header > .row').height($('#tab2').outerHeight());
      $('.triagetool-wrapper').css('display', 'block');
    }, 1000);
  } else {
    $('.frontpage header').removeClass().addClass('before-five');
    $('.triagetool-wrapper').css('display', 'none');
    setTimeout(function () {
      $('.frontpage header > .row').height($('#tab1').outerHeight());

    }, 1000);
  }


  setTimeout(function () {
    $('.huisartsenpost header > .row').height($('#tab2').outerHeight());
    $('.huisarts header > .row').height($('#tab1').outerHeight());
  }, 1000);

  // Praktijk
  function setHeaderHeight() {
    if ($('.praktijk').length > 0) {
      var navHeight = $('.praktijk nav').outerHeight();

      if ($(window).width() < 993) {
        var navMiddleHeight = $('.praktijk .nav-middle').outerHeight() + 50;

        if (isNaN(navMiddleHeight)) {
          $('.praktijk header').css('margin-top', navHeight);
        } else {
          $('.praktijk header').css('margin-top', navMiddleHeight);
        }
      } else {
        $('.praktijk header').css('margin-top', navHeight);
      }
    }
  }

  setHeaderHeight(); // Praktijk

  // RESIZE
  $(window).on('resize', function () {
    if ($('.frontpage header').hasClass('after-five')) {
      $('.frontpage header > .row').height($('#tab2').outerHeight());
    } else {
      $('.frontpage header > .row').height($('#tab1').outerHeight());
    }

    $('.huisartsenpost header > .row').height($('#tab2').outerHeight());
    $('.huisarts header > .row').height($('#tab1').outerHeight());

    setHeaderHeight(); // Praktijk
  });

  $(window).scroll(function () {
    Scrolled();
  });

  // INIT
  Scrolled();

  var delayTimer;

  $('#search-form input[name="s"]').on("change paste keyup", function () {
    clearTimeout(delayTimer);

    delayTimer = setTimeout(function () {
      suggestions('#search-form');
    }, 500); // Will do the ajax stuff after 1000 ms, or 1 s
  });

  $(document).mouseup(function (e) {
    var container = $('#search-form, .search-results');

    if (!container.is(e.target) // if the target of the click isn't the container...
      &&
      container.has(e.target).length === 0) { // ... nor a descendant of the container
      $('.search-results').removeClass('active');
    }
  });

  // Search form
  function suggestions(form) {
    var $form = $(form);
    var $input = $form.find('input[name="s"]');
    var query = $input.val();
    var $content = $('.search-results');

    $.ajax({
      type: 'post',
      url: "/wp-admin/admin-ajax.php",
      data: {
        action: 'load_search_results',
        query: query
      },
      beforeSend: function () {
        $input.prop('disabled', true);
        $content.html('');
        $content.addClass('loading');
      },
      success: function (response) {
        $input.prop('disabled', false);
        $content.removeClass('loading').addClass('active');
        $content.html(response);
      }
    });
  }

  // Set cookie when popup has been showed
  if ($('#popup').length > 0) {
    var id = $('#popup').data('id');
    var popup = new Foundation.Reveal($('#popup[data-id="' + id + '"]'));

    if (Cookies.get('popup-' + id) != 'ja') {
      popup.open();
      Cookies.set('popup-' + id, 'ja', {
        expires: 1,
        path: '/'
      });
    }
  }
});

$(document).foundation();

if (module.hot) {
  module.hot.accept()
}